module.exports = __webpack_public_path__ + "img/special_wild.1f041421.png";